import {
  BATTLE_RHYTHMS_SET,
  BATTLE_RHYTHM_ADDED,
  BATTLE_RHYTHM_EDITED,
  BATTLE_RHYTHM_DELETED,
} from 'src/app/redux/redux-types';
import { reduxBattleRhythmTypes } from 'src/types';

export const battleRhythmDefaultState: reduxBattleRhythmTypes.StateType = {
  battleRhythmList: [],
};

export const battleRhythmReducer = (
  state = battleRhythmDefaultState,
  action: reduxBattleRhythmTypes.ActionType,
): reduxBattleRhythmTypes.StateType => {
  switch (action.type) {
    case BATTLE_RHYTHMS_SET:
      return {
        ...state,
        battleRhythmList: action.payload,
      };
    case BATTLE_RHYTHM_ADDED:
      const exists = state.battleRhythmList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        battleRhythmList: [action.payload, ...state.battleRhythmList],
      };
    case BATTLE_RHYTHM_EDITED:
      const updateIndex = state.battleRhythmList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        battleRhythmList: [
          ...state.battleRhythmList.slice(0, updateIndex),
          action.payload,
          ...state.battleRhythmList.slice(updateIndex + 1),
        ],
      };
    case BATTLE_RHYTHM_DELETED:
      return {
        ...state,
        battleRhythmList: state.battleRhythmList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
